/* eslint-disable camelcase */
import { createContext, useContext } from 'react'
import type { ChannelGroup_ChannelGroup } from '~publish/pages/Settings/ChannelGroups/hooks/useChannelGroups'

type ChannelGroupsContext = {
  selectedChannelGroupIds: Set<string>
  channelGroups: ChannelGroup_ChannelGroup[] | null
  loading: boolean
  error: boolean
}

export const ChannelGroupsContext = createContext<ChannelGroupsContext>({
  selectedChannelGroupIds: new Set(),
  channelGroups: null,
  loading: false,
  error: false,
})

export const useChannelGroupsContext = (): ChannelGroupsContext => {
  const context = useContext(ChannelGroupsContext)
  if (context === undefined) {
    throw new Error(
      'useChannelGroupsContext must be used within a ChannelGroupsContext',
    )
  }
  return context
}
